import { useContext } from "react";
import { FormConcluedContext } from "../context/FormConcluedContext";

export const useFormConclued = () => {
    const context = useContext(FormConcluedContext);

    if (!context) {
        throw new Error("useFormConclued must be used");
    }

    return context;
};
